export const hardcodedSettingsConstants = {
    GET_SUPER_ADMINS_REQUEST: 'GET_SUPER_ADMINS_REQUEST',
    GET_SUPER_ADMINS_SUCCESS: 'GET_SUPER_ADMINS_SUCCESS',
    GET_SUPER_ADMINS_ERROR: 'GET_SUPER_ADMINS_ERROR'
};
